import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaStar, FaShoppingCart } from 'react-icons/fa';


function DetaliiAnunt() {
  const { id } = useParams();
  const [anunt, setAnunt] = useState(null);
  const [incarca, setIncarca] = useState(true);
  const [indexImagine, setIndexImagine] = useState(0);
  const [arataTelefon, setArataTelefon] = useState(false);

  const [modalMesaj, setModalMesaj] = useState(false);
  const [textMesaj, setTextMesaj] = useState('');
  const [trimite, setTrimite] = useState(false);
  const [modalOferta, setModalOferta] = useState(false);
  const [pretOferta, setPretOferta] = useState('');
  const [trimiteOferta, setTrimiteOferta] = useState(false);
  const [utilizatorLogat, setUtilizatorLogat] = useState(null);

  const [recenzii, setRecenzii] = useState([]);
  const [modalRecenzie, setModalRecenzie] = useState(false);
  const [nota, setNota] = useState(5);
  const [comentariu, setComentariu] = useState('');
  const [trimiteRecenzie, setTrimiteRecenzie] = useState(false);

  const [modalCumpara, setModalCumpara] = useState(false);
  const [cumparaLoading, setCumparaLoading] = useState(false);
  const [dateLivrare, setDateLivrare] = useState({
    numeDestinatarLivrare: '',
    telefonLivrare: '',
    adresaLivrare: ''
  });

  useEffect(() => {
  preiaAnunt();
  const userString = localStorage.getItem('utilizator');
  if (userString) {
    const user = JSON.parse(userString);
    setUtilizatorLogat({ id: String(user._id || user.id) });
  }
}, [id]);

  const preiaAnunt = async () => {
    try {
      const raspuns = await fetch(`https://tranzitio.onrender.com/api/anunturi/${id}`);
      if (raspuns.ok) {
        const date = await raspuns.json();
        setAnunt(date);
        let idVanzator = date.utilizator;
        if (typeof date.utilizator === 'object' && date.utilizator !== null) {
          idVanzator = date.utilizator._id;
        }
        preiaRecenzii(idVanzator);
      } else {
        toast.error('Anuntul nu a putut fi gasit');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la incarcarea anuntului');
    } finally {
      setIncarca(false);
    }
  };

  const preiaRecenzii = async (idVanzator) => {
    try {
      const raspuns = await fetch(`https://tranzitio.onrender.com/api/recenzii/${idVanzator}`);
      if (raspuns.ok) {
        const date = await raspuns.json();
        setRecenzii(date);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleTrimiteMesaj = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Trebuie sa fii autentificat pentru a trimite un mesaj.');
      setModalMesaj(false);
      return;
    }
    if (textMesaj.trim().length < 10) {
      toast.error('Mesajul trebuie sa aiba macar 10 caractere.');
      return;
    }
    let idDestinatar = anunt.utilizator;
    if (typeof anunt.utilizator === 'object' && anunt.utilizator !== null) {
      idDestinatar = anunt.utilizator._id;
    }
    setTrimite(true);
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify({ destinatar: idDestinatar, anunt: anunt._id, text: textMesaj })
      });
      if (raspuns.ok) {
        toast.success('Mesajul a fost trimis catre vanzator!');
        setModalMesaj(false);
        setTextMesaj('');
      } else {
        const dateEroare = await raspuns.json();
        toast.error(dateEroare.mesaj || 'Eroare la trimiterea mesajului.');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la trimitere.');
    } finally {
      setTrimite(false);
    }
  };

  async function handleTrimiteOferta() {
  if (!pretOferta || Number(pretOferta) <= 0) {
    toast.error('Introdu un pret valid pentru oferta!');
    return;
  }
  const token = localStorage.getItem('token');
  if (!token) {
    toast.error('Trebuie sa fii logat!');
    return;
  }
  setTrimiteOferta(true);
  try {
    const raspuns = await fetch('https://tranzitio.onrender.com/api/mesaje/oferta', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
      body: JSON.stringify({
        idDestinatarOferta: anunt.utilizator._id || anunt.utilizator,
        idAnuntOferta: anunt._id,
        pretOferta: Number(pretOferta)
      })
    });
    const date = await raspuns.json();
    if (raspuns.ok) {
      toast.success('Oferta trimisa cu succes!');
      setModalOferta(false);
      setPretOferta('');
    } else {
      toast.error(date.mesaj);
    }
  } catch (err) {
    toast.error('Eroare la trimiterea ofertei');
  } finally {
    setTrimiteOferta(false);
  }
}

  const handleDeschideCumpara = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Trebuie sa fii autentificat pentru a cumpara.');
      return;
    }
    setModalCumpara(true);
  };

  const handleConfirmaComanda = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    let idVanzator = anunt.utilizator;
    if (typeof anunt.utilizator === 'object' && anunt.utilizator !== null) {
      idVanzator = anunt.utilizator._id;
    }

    setCumparaLoading(true);
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/comenzi', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify({
          anunt: anunt._id,
          vanzator: idVanzator,
          numeDestinatarLivrare: dateLivrare.numeDestinatarLivrare,
          telefonLivrare: dateLivrare.telefonLivrare,
          adresaLivrare: dateLivrare.adresaLivrare
        })
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        setModalCumpara(false);
        setDateLivrare({ numeDestinatarLivrare: '', telefonLivrare: '', adresaLivrare: '' });
      } else {
        toast.error(date.mesaj);
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la plasarea comenzii.');
    } finally {
      setCumparaLoading(false);
    }
  };

  const handleTrimiteRecenzie = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('utilizator');
    if (!token || !userString) {
      toast.error('Trebuie sa fii logat pentru a lasa o recenzie.');
      setModalRecenzie(false);
      return;
    }
    const user = JSON.parse(userString);
    let idVanzator = anunt.utilizator;
    if (typeof anunt.utilizator === 'object' && anunt.utilizator !== null) {
      idVanzator = anunt.utilizator._id;
    }
    setTrimiteRecenzie(true);
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/recenzii', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify({ vanzator: idVanzator, nota, comentariu, numeAutor: user.nume })
      });
      const date = await raspuns.json();
      if (raspuns.ok) {
        toast.success(date.mesaj);
        setModalRecenzie(false);
        setComentariu('');
        setNota(5);
        preiaRecenzii(idVanzator);
      } else {
        toast.error(date.mesaj);
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune.');
    } finally {
      setTrimiteRecenzie(false);
    }
  };

  const formateazaData = (dataString) => {
    if (!dataString) return 'Data nespecificata';
    try {
      const d = new Date(dataString);
      if (!isNaN(d.getTime())) return d.toLocaleDateString('ro-RO');
    } catch(e) {}
    return String(dataString).substring(0, 10);
  };

  const text = (val) => {
    if (val === null || val === undefined) return 'Nespecificat';
    if (typeof val === 'string') return val;
    if (typeof val === 'number') return String(val);
    if (typeof val === 'object') {
      if (val.nume) return String(val.nume);
      return 'Eroare format';
    }
    return String(val);
  };

  const mediaNotelor = recenzii.length > 0
    ? (recenzii.reduce((acc, curr) => acc + curr.nota, 0) / recenzii.length).toFixed(1)
    : 0;

  if (incarca) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!anunt) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
        <div className="bg-white p-10 rounded-2xl shadow-sm border border-gray-100 text-center max-w-md w-full">
          <h2 className="text-2xl font-black text-gray-800 mb-2">Anuntul nu exista</h2>
          <p className="text-gray-500 mb-8">Acest anunt a fost sters sau link-ul este invalid.</p>
          <Link to="/" className="bg-blue-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-blue-700 transition w-full block">
            Inapoi la prima pagina
          </Link>
        </div>
      </div>
    );
  }

  let poze = [];
  if (Array.isArray(anunt.imagini)) {
    poze = anunt.imagini.filter(img => typeof img === 'string');
  } else if (typeof anunt.imagine === 'string' && anunt.imagine.length > 0) {
    poze = [anunt.imagine];
  }

  const numeVanzator = text(anunt.numeContact);
  const literaVanzator = numeVanzator !== 'Nespecificat' && numeVanzator !== 'Eroare format' ? numeVanzator.charAt(0).toUpperCase() : 'U';

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-16">
      <div className="bg-white border-b border-gray-200 py-4 mb-8 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <div className="flex flex-wrap items-center gap-2 text-sm font-medium">
            <Link to="/" className="text-gray-500 hover:text-blue-600 transition">Acasa</Link>
            <svg className="w-4 h-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
            <span className="text-gray-500">{text(anunt.categorie)}</span>
            <svg className="w-4 h-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
            <span className="text-gray-900 font-bold bg-gray-100 px-3 py-1 rounded-full">{text(anunt.subcategorie)}</span>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-8">

          <div className="w-full lg:w-2/3 flex flex-col gap-8">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 md:p-8">
                <h1 className="text-2xl md:text-4xl font-black text-gray-900 mb-6 leading-tight">{text(anunt.titlu)}</h1>
                <div className="aspect-[4/3] bg-gray-50 flex items-center justify-center relative rounded-xl overflow-hidden mb-4 border border-gray-100">
                  {poze.length > 0 ? (
                    <>
                      <div className="absolute inset-0 bg-cover bg-center opacity-40 blur-xl scale-110" style={{ backgroundImage: `url(${poze[indexImagine]})` }}></div>
                      <img src={poze[indexImagine]} alt="Imagine anunt" className="w-full h-full object-contain relative z-10" />
                    </>
                  ) : (
                    <div className="flex flex-col items-center justify-center text-gray-400">
                      <svg className="w-16 h-16 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                      <span className="font-bold">Fara imagini</span>
                    </div>
                  )}
                  {poze.length > 1 && (
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-gray-900/80 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-sm font-bold z-20">
                      {indexImagine + 1} / {poze.length}
                    </div>
                  )}
                </div>
                {poze.length > 1 && (
                  <div className="flex gap-3 overflow-x-auto py-2">
                    {poze.map((img, idx) => (
                      <button key={idx} onClick={() => setIndexImagine(idx)}
                        className={`shrink-0 w-24 h-24 rounded-xl overflow-hidden transition-all duration-200 ${indexImagine === idx ? 'ring-4 ring-blue-600 ring-offset-2 scale-95' : 'ring-1 ring-gray-200 opacity-70 hover:opacity-100'}`}>
                        <img src={img} alt={`Miniatura ${idx + 1}`} className="w-full h-full object-cover" />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                Detalii principale
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100/50">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Stare</span>
                  <span className="font-black text-gray-900">{text(anunt.stare)}</span>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Tip oferta</span>
                  <span className="font-black text-gray-900">{text(anunt.tipOferta)}</span>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Vanzator</span>
                  <span className="font-black text-gray-900">{text(anunt.tipPersoana)}</span>
                </div>
                <div className="bg-green-50 p-4 rounded-xl border border-green-100">
                  <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Negociabil</span>
                  <span className="font-black text-green-700">{anunt.negociabil ? 'Da' : 'Nu'}</span>
                </div>
              </div>
              <div className="w-full h-px bg-gray-100 mb-8"></div>
              <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" /></svg>
                Descriere
              </h2>
              <div className="text-gray-700 leading-loose whitespace-pre-wrap text-lg">{text(anunt.descriere)}</div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                  <FaStar className="w-6 h-6 text-amber-400" />
                  Recenzii Vanzator ({recenzii.length})
                </h2>
                <button onClick={() => setModalRecenzie(true)} className="bg-blue-50 text-blue-700 font-bold px-4 py-2 rounded-lg hover:bg-blue-100 transition text-sm">
                  Lasa o recenzie
                </button>
              </div>
              {recenzii.length === 0 ? (
                <div className="text-center py-8 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-gray-500 font-medium">Acest vanzator nu are nicio recenzie inca. Fii primul!</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {recenzii.map(rec => (
                    <div key={rec._id} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <span className="font-bold text-gray-900">{rec.numeAutor}</span>
                          <span className="text-xs text-gray-400 ml-2">{formateazaData(rec.data)}</span>
                        </div>
                        <div className="flex text-amber-400">
                          {[...Array(5)].map((_, i) => (
                            <FaStar key={i} className={i < rec.nota ? "text-amber-400" : "text-gray-200"} />
                          ))}
                        </div>
                      </div>
                      <p className="text-gray-700 text-sm leading-relaxed">{rec.comentariu}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>


          <div className="w-full lg:w-1/3">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8 sticky top-8 z-30">
              <div className="mb-8">
                <p className="text-sm text-gray-500 font-bold uppercase tracking-wider mb-2">Pret solicitat</p>
                <h2 className="text-4xl md:text-5xl font-black text-blue-700 break-words tracking-tight">
                  {text(anunt.pret)} <span className="text-2xl font-bold text-gray-500">{text(anunt.moneda)}</span>
                </h2>
              </div>

              <div className="flex flex-col gap-4 mb-8">
                <button
                  onClick={handleDeschideCumpara}
                  className="w-full flex items-center justify-center gap-3 bg-emerald-500 text-white font-bold text-lg py-4 rounded-xl hover:bg-emerald-600 transition shadow-md hover:shadow-lg active:scale-95"
                >
                  <FaShoppingCart className="w-6 h-6" />
                  Cumpara Acum
                </button>
                {anunt.negociabil === true && utilizatorLogat && utilizatorLogat.id !== (anunt.utilizator._id || anunt.utilizator) && (
                  <button
                    onClick={function() { setModalOferta(true); }}
                    className="w-full flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-bold py-3.5 px-6 rounded-xl transition shadow-md mt-3"
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Fa o oferta
                  </button>
                )}

                {modalOferta === true && (
                  <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
                      <div className="flex items-center justify-between mb-6">
                        <h3 className="text-xl font-bold text-gray-900">Fa o oferta</h3>
                        <button
                          onClick={function() { setModalOferta(false); setPretOferta(''); }}
                          className="text-gray-400 hover:text-gray-600 p-1"
                        >
                          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>

                      <div className="bg-amber-50 rounded-xl p-4 mb-5">
                        <p className="text-sm text-amber-700 font-medium">
                          Pret curent: <strong>{anunt.pret} {anunt.moneda || 'RON'}</strong>
                        </p>
                        <p className="text-xs text-amber-600 mt-1">Vanzatorul va fi notificat si poate accepta, refuza sau face o contra-oferta.</p>
                      </div>

                      <div className="mb-5">
                        <label className="block text-sm font-bold text-gray-700 mb-2">Oferta ta (RON)</label>
                        <input
                          type="number"
                          value={pretOferta}
                          onChange={function(e) { setPretOferta(e.target.value); }}
                          placeholder={'Ex: ' + Math.round(anunt.pret * 0.85)}
                          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-lg font-bold focus:outline-none focus:border-amber-500 transition"
                        />
                      </div>

                      <div className="flex gap-3">
                        <button
                          onClick={function() { setModalOferta(false); setPretOferta(''); }}
                          className="flex-1 py-3 rounded-xl font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
                        >
                          Anuleaza
                        </button>
                        <button
                          onClick={handleTrimiteOferta}
                          disabled={trimiteOferta}
                          className="flex-1 py-3 rounded-xl font-bold text-white bg-amber-500 hover:bg-amber-600 transition disabled:opacity-50"
                        >
                          {trimiteOferta ? 'Se trimite...' : 'Trimite oferta'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => setModalMesaj(true)}
                    className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition shadow-md text-sm"
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>
                    Mesaj
                  </button>
                  <button
                    onClick={() => setArataTelefon(!arataTelefon)}
                    className={`w-full flex items-center justify-center gap-2 font-bold py-3 rounded-xl transition border-2 text-sm ${arataTelefon ? 'bg-green-50 border-green-500 text-green-700' : 'bg-white border-gray-200 text-gray-800 hover:border-blue-600 hover:text-blue-600'}`}
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                    {arataTelefon ? text(anunt.telefonContact) : 'Telefon'}
                  </button>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-5 mb-8 border border-gray-100">
                <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-4">Informatii Vanzator</p>
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center text-blue-700 font-black text-2xl shadow-inner border border-blue-200">
                    {literaVanzator}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{numeVanzator}</h3>
                    {recenzii.length > 0 ? (
                      <div className="flex items-center gap-1 mt-1">
                        <FaStar className="text-amber-400 w-4 h-4" />
                        <span className="font-bold text-gray-800">{mediaNotelor}</span>
                        <span className="text-xs text-gray-500 ml-1">({recenzii.length} recenzii)</span>
                      </div>
                    ) : (
                      <div className="text-xs text-gray-500 mt-1">Fara recenzii</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center shrink-0">
                    <svg className="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  </div>
                  <div className="pt-1">
                    <h4 className="font-bold text-gray-900 text-lg">{text(anunt.localitate)}</h4>
                    <p className="text-gray-500">Jud. {text(anunt.judet)}</p>
                  </div>
                </div>
                <div className="mt-6 w-full h-48 rounded-xl overflow-hidden border border-gray-100 shadow-inner relative">
                  <iframe
                    width="100%" height="100%" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" title="map"
                    src={`https://maps.google.com/maps?q=${encodeURIComponent(text(anunt.localitate) + ', ' + text(anunt.judet) + ', Romania')}&t=&z=11&ie=UTF8&iwloc=&output=embed`}
                  ></iframe>
                </div>
              </div>

              <div className="pt-6 border-t border-gray-100 flex justify-between text-xs font-medium text-gray-400">
                <span className="bg-gray-100 px-2 py-1 rounded">ID: {id.substring(0, 8)}</span>
                <span className="flex items-center gap-1">
                  <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                  {formateazaData(anunt.data)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalCumpara && (
        <div className="fixed inset-0 z-50 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-emerald-50">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <FaShoppingCart className="w-6 h-6 text-emerald-600" />
                Confirma comanda
              </h3>
              <button onClick={() => setModalCumpara(false)} className="bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full p-2 transition">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <form onSubmit={handleConfirmaComanda} className="p-6 md:p-8">
              <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-100">
                <p className="text-sm text-gray-500 font-medium">Produs</p>
                <p className="font-bold text-gray-900">{text(anunt.titlu)}</p>
                <p className="text-emerald-700 font-black text-lg mt-1">{text(anunt.pret)} {text(anunt.moneda)}</p>
              </div>

              <p className="text-sm font-bold text-gray-700 mb-4">Completeaza datele de livrare:</p>

              <div className="flex flex-col gap-4 mb-6">
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Nume complet destinatar</label>
                  <input
                    type="text"
                    required
                    value={dateLivrare.numeDestinatarLivrare}
                    onChange={(e) => setDateLivrare({ ...dateLivrare, numeDestinatarLivrare: e.target.value })}
                    placeholder="ex: Ion Popescu"
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Numar de telefon</label>
                  <input
                    type="tel"
                    required
                    value={dateLivrare.telefonLivrare}
                    onChange={(e) => setDateLivrare({ ...dateLivrare, telefonLivrare: e.target.value })}
                    placeholder="ex: 0712345678"
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">Adresa de livrare</label>
                  <textarea
                    required
                    rows={3}
                    value={dateLivrare.adresaLivrare}
                    onChange={(e) => setDateLivrare({ ...dateLivrare, adresaLivrare: e.target.value })}
                    placeholder="ex: Str. Mihai Eminescu nr. 10, Bloc A, Ap. 5, Ploiesti, Prahova"
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition resize-none"
                  ></textarea>
                </div>
              </div>

              <div className="flex gap-4">
                <button type="button" onClick={() => setModalCumpara(false)}
                  className="w-1/3 bg-white border border-gray-200 text-gray-700 font-bold py-3.5 rounded-xl hover:bg-gray-50 transition" disabled={cumparaLoading}>
                  Anuleaza
                </button>
                <button type="submit"
                  className="w-2/3 bg-emerald-500 text-white font-bold py-3.5 rounded-xl hover:bg-emerald-600 transition shadow-md flex justify-center items-center gap-2" disabled={cumparaLoading}>
                  {cumparaLoading ? (
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  ) : (
                    <>
                      <FaShoppingCart className="w-5 h-5" />
                      Plaseaza comanda
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {modalMesaj && (
        <div className="fixed inset-0 z-50 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-gray-50/50">
              <h3 className="text-xl font-bold text-gray-900">Mesaj nou</h3>
              <button onClick={() => setModalMesaj(false)} className="bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full p-2 transition">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <form onSubmit={handleTrimiteMesaj} className="p-6 md:p-8">
              <p className="text-gray-600 mb-6 leading-relaxed">
                Ii trimiti un mesaj lui <span className="font-bold text-gray-900">{numeVanzator}</span> pentru anuntul <span className="font-bold text-gray-900">{text(anunt.titlu)}</span>.
              </p>
              <textarea value={textMesaj} onChange={(e) => setTextMesaj(e.target.value)}
                placeholder="Buna ziua, sunt interesat de acest anunt. Mai este valabil?"
                rows={5} required
                className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-800 focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 resize-none mb-8 transition"
              ></textarea>
              <div className="flex gap-4">
                <button type="button" onClick={() => setModalMesaj(false)}
                  className="w-1/3 bg-white border border-gray-200 text-gray-700 font-bold py-3.5 rounded-xl hover:bg-gray-50 transition" disabled={trimite}>
                  Anuleaza
                </button>
                <button type="submit"
                  className="w-2/3 bg-blue-600 text-white font-bold py-3.5 rounded-xl hover:bg-blue-700 transition shadow-md flex justify-center items-center gap-2" disabled={trimite}>
                  {trimite ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> : 'Trimite'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {modalRecenzie && (
        <div className="fixed inset-0 z-50 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b border-gray-100 bg-gray-50/50">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <FaStar className="w-6 h-6 text-amber-400" />
                Evalueaza Vanzatorul
              </h3>
              <button onClick={() => setModalRecenzie(false)} className="bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-full p-2 transition">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <form onSubmit={handleTrimiteRecenzie} className="p-6 md:p-8">
              <div className="mb-6 text-center">
                <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2">Alege o nota</p>
                <div className="flex justify-center gap-2 cursor-pointer">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar key={star}
                      className={`w-10 h-10 transition-colors ${star <= nota ? 'text-amber-400' : 'text-gray-200 hover:text-amber-200'}`}
                      onClick={() => setNota(star)} />
                  ))}
                </div>
              </div>
              <textarea value={comentariu} onChange={(e) => setComentariu(e.target.value)}
                placeholder="Cum a decurs comunicarea cu vanzatorul? Ai fost multumit?"
                rows={4} required
                className="w-full bg-gray-50 border border-gray-200 rounded-xl p-4 text-gray-800 focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-100 resize-none mb-8 transition"
              ></textarea>
              <div className="flex gap-4">
                <button type="button" onClick={() => setModalRecenzie(false)}
                  className="w-1/3 bg-white border border-gray-200 text-gray-700 font-bold py-3.5 rounded-xl hover:bg-gray-50 transition" disabled={trimiteRecenzie}>
                  Anuleaza
                </button>
                <button type="submit"
                  className="w-2/3 bg-amber-400 text-amber-900 font-black py-3.5 rounded-xl hover:bg-amber-500 transition shadow-md flex justify-center items-center gap-2" disabled={trimiteRecenzie}>
                  {trimiteRecenzie ? <div className="w-5 h-5 border-2 border-amber-900/30 border-t-amber-900 rounded-full animate-spin"></div> : 'Publica Recenzia'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default DetaliiAnunt;